// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_llzSV {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
}

.bgFixed_cjNe1 {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
}

.ShowSelectCurrencyPopup_HDz17 {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--f5-background);
  z-index: 999999;
  border-radius: 10px;
  overflow: hidden;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  @media (width<768px) {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
}
.scroll_iPSsl{
  overflow-y: scroll;
  height: 400px;
  background-color: var(--white-color);

  width: 90%;
  margin: 0 auto 20px;
  @media (width<768px) {
    height: 85%;
  }
}

.currencyContent_Al_j4 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;

  p {
    margin: 0;
  }
  .currencyName_oTZ6u {
    color: #404145;
  }
  .currencyDesc_HB8lV {
    color: #74767e;
  }
  .currencyItem_acRhX {
    justify-content: space-between;
    align-items: center;
    display: flex;
  }
  .selectedName_XCVIH {
    font-weight: bold;
  }
}
.currencyContent_Al_j4::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SelectCurrencyPopup/SelectCurrencyPopup.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;;EAEpC,UAAU;EACV,mBAAmB;EACnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;;EAEZ;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;AACf","sourcesContent":[".bg {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n}\n\n.bgFixed {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n}\n\n.ShowSelectCurrencyPopup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--f5-background);\n  z-index: 999999;\n  border-radius: 10px;\n  overflow: hidden;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  @media (width<768px) {\n    height: 100vh;\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n.scroll{\n  overflow-y: scroll;\n  height: 400px;\n  background-color: var(--white-color);\n\n  width: 90%;\n  margin: 0 auto 20px;\n  @media (width<768px) {\n    height: 85%;\n  }\n}\n\n.currencyContent {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 100%;\n\n  p {\n    margin: 0;\n  }\n  .currencyName {\n    color: #404145;\n  }\n  .currencyDesc {\n    color: #74767e;\n  }\n  .currencyItem {\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n  }\n  .selectedName {\n    font-weight: bold;\n  }\n}\n.currencyContent::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_llzSV`,
	"bgFixed": `bgFixed_cjNe1`,
	"ShowSelectCurrencyPopup": `ShowSelectCurrencyPopup_HDz17`,
	"scroll": `scroll_iPSsl`,
	"currencyContent": `currencyContent_Al_j4`,
	"currencyName": `currencyName_oTZ6u`,
	"currencyDesc": `currencyDesc_HB8lV`,
	"currencyItem": `currencyItem_acRhX`,
	"selectedName": `selectedName_XCVIH`
};
export default ___CSS_LOADER_EXPORT___;
